import axios from 'axios'
import { REACT_APP_PERITADOR_API } from '../../config'
import { vAttributeReducer } from './vAttributesReducer'

export async function getAllVAttributesByVerificationID(args) {
  const vAttributes = await axios.get(
    `${REACT_APP_PERITADOR_API}/vAttributes/verificationId/getAllVAttributes?verificationsId=${args}`
  )

  return vAttributeReducer(vAttributes?.data)
}
